import { FunctionComponent, PropsWithChildren } from 'react';

interface SwitchCaseProps extends PropsWithChildren {
  value: any;
}

export const Case: FunctionComponent<SwitchCaseProps> = ({ children }) => {
  return <>{children}</>;
};
